/// <amd-module name="Environments/CreatePanel/ActionsCreators/EnvironmentsCreatePanelActionsCreator" />
import { ActionCreatorBase } from "Environments/Flux/ActionCreatorBase";
import { ActionsHubManager } from "Environments/Flux/ActionsHubManager";
import { EnvironmentsCreatePanelActions } from "Environments/CreatePanel/Actions/EnvironmentsCreatePanelActions";
import { MessagesActions } from "Environments/EnvironmentsCommon/MessagesActions";

import { IEnvironmentService } from "Environments/Client/EnvironmentService";
import { EnvironmentInstance, EnvironmentCreateParameter, EnvironmentUpdateParameter } from "DistributedTask/Client/Contracts/TaskAgent";
import { IVssPageContext } from "VSS/Platform/Context";
import { PageKey, getErrorMessage } from "Environments/CreatePanel/Common/Utils";
import { publishTelemetry } from "Environments/EnvironmentsCommon/Telemetry";
import { Area, FeatureNames, Action }from "Environments/CreatePanel/Common/Utils";

export class EnvironmentsCreatePanelActionsCreator extends ActionCreatorBase {

    public static getKey(): string {
        return "environments-create-panel-action-creator";
    }

    public initialize(instanceId?: string) {
        super.initialize(instanceId);
        
        this._actions = ActionsHubManager.CreateActionsHub<EnvironmentsCreatePanelActions>(EnvironmentsCreatePanelActions, instanceId);
        this._messageActions = ActionsHubManager.CreateActionsHub<MessagesActions>(MessagesActions, instanceId);
    }

    public createEnvironment(pageContext: IVssPageContext, environmentName: string, environmentDescription: string, callback?: (id: number) => void): void {
        const environmentService = pageContext.getService<IEnvironmentService>("IEnvironmentService");
        const environmentCreateParameters: EnvironmentCreateParameter = {
            description: environmentDescription,
            name: environmentName
        };
        environmentService.addEnvironment(environmentCreateParameters).then((environment: EnvironmentInstance) => {
            this._messageActions.clearMessage.invoke(PageKey.AddEnvironmentView);
            if (callback) {
                // Need to remove after 1-2 sprint
                publishTelemetry(pageContext, Area, FeatureNames.EnvironmentCreationType, { "CreatedWithoutResource": "true" ,"Source": "Environment-UI" ,"EnvironmentId": environment.id.toString(), "EnvironmentName": environment.name});
                publishTelemetry(pageContext, Area, FeatureNames.EnvironmentCreationWorkFlow, { "Action": Action.EnvironmentCreationType, "CreatedWithResource": "false" ,"Source": "Environment-UI" ,"EnvironmentId": environment.id.toString()});
                callback(environment.id);
            }
            else {
                // Need to remove after 1-2 sprint
                publishTelemetry(pageContext, Area, FeatureNames.EnvironmentCreationType, { "CreatedWithoutResource": "false","Source": "Environment-UI", "EnvironmentId": environment.id.toString(), "EnvironmentName": environment.name});
                publishTelemetry(pageContext, Area, FeatureNames.EnvironmentCreationWorkFlow, { "Action": Action.EnvironmentCreationType, "CreatedWithResource": "true" ,"Source": "Environment-UI" ,"EnvironmentId": environment.id.toString()});
                this._actions.createEnvironment.invoke(environment);
            }
        },
        (error) => {
            this._messageActions.addMessage.invoke({ key: PageKey.AddEnvironmentView, value: getErrorMessage(error) }); 
        });
        
    }

    public updateEnvironment(pageContext: IVssPageContext, environmentId: number, environmentName: string, environmentDescription: string, callback: (env: EnvironmentInstance) => void): void {
        const environmentService = pageContext.getService<IEnvironmentService>("IEnvironmentService");
        const environmentUpdateParameter: EnvironmentUpdateParameter = {
            description: environmentDescription,
            name: environmentName
        };
        environmentService.updateEnvironment(environmentUpdateParameter, environmentId).then((environment: EnvironmentInstance) => {
            this._messageActions.clearMessage.invoke(PageKey.EditEnvironmentView);
            callback(environment);
        },
        (error) => {
            this._messageActions.addMessage.invoke({ key: PageKey.EditEnvironmentView, value: getErrorMessage(error) });
        });
    }

    protected disposeInternal(): void {
        ActionsHubManager.DeleteActionsHub<EnvironmentsCreatePanelActions>(EnvironmentsCreatePanelActions, this.getInstanceId());
        ActionsHubManager.DeleteActionsHub<MessagesActions>(MessagesActions, this.getInstanceId());
    }

    private _actions: EnvironmentsCreatePanelActions;
    private _messageActions: MessagesActions;
}
